import type { FC } from "react";
import { useEffect, useRef, useState } from "react";
import { ChartWrapper } from "../components/view-by-domain-chart/StyledComponents";

interface ChartWrapperWithKeyProps {
    dependency: unknown;
}

const ChartWrapperWithKey: FC<React.PropsWithChildren<ChartWrapperWithKeyProps>> = ({ children, dependency }) => {
    const [chartKey, setChartKey] = useState(() => Math.random());
    const isMountedRef = useRef(false);
    useEffect(() => {
        if (isMountedRef.current) {
            setChartKey(Math.random());
        }
        isMountedRef.current = true;
    }, [dependency]);
    return <ChartWrapper key={chartKey}>{children}</ChartWrapper>;
};

export default ChartWrapperWithKey;
